import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as o } from "../../chunks/tslib.es6.js";
import "../../geometry.js";
import t from "../../core/Evented.js";
import { property as e } from "../../core/accessorSupport/decorators/property.js";
import "../../core/arrayUtils.js";
import "../../core/has.js";
import "../../core/accessorSupport/ensureType.js";
import { subclass as s } from "../../core/accessorSupport/decorators/subclass.js";
import r from "../../layers/support/LOD.js";
import { GeometryConstraint as i } from "./constraints/GeometryConstraint.js";
import a from "./constraints/RotationConstraint.js";
import n from "./constraints/ZoomConstraint.js";
import m from "../../geometry/Extent.js";
import l from "../../geometry/Polygon.js";
var p = {
  base: null,
  key: "type",
  typeMap: {
    extent: m,
    polygon: l
  }
};

var c = /*#__PURE__*/function (_t$EventedAccessor) {
  _inherits(c, _t$EventedAccessor);

  var _super = _createSuper(c);

  function c() {
    var _this;

    _classCallCheck(this, c);

    _this = _super.apply(this, arguments), _this.lods = null, _this.minScale = 0, _this.maxScale = 0, _this.minZoom = -1, _this.maxZoom = -1, _this.rotationEnabled = !0, _this.snapToZoom = !0;
    return _this;
  }

  _createClass(c, [{
    key: "initialize",
    value: function initialize() {
      this.watch(["_zoom", "_rotation"], this.emit.bind(this, "update"), !0);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.view = null, this._set("_zoom", null), this._set("_rotation", null);
    }
  }, {
    key: "geometry",
    set: function set(o) {
      o ? this._set("geometry", o) : this._set("geometry", null);
    }
  }, {
    key: "_defaultLODs",
    get: function get() {
      var o, t, e;
      var s = null == (o = this.view) || null == (t = o.defaultsFromMap) ? void 0 : t.tileInfo,
          r = null == (e = this.view) ? void 0 : e.spatialReference;
      return s && r && s.spatialReference.equals(r) ? s.lods : null;
    }
  }, {
    key: "_geometry",
    get: function get() {
      return new i({
        geometry: this.geometry,
        spatialReference: this.view.spatialReference
      });
    }
  }, {
    key: "_rotation",
    get: function get() {
      return new a({
        rotationEnabled: this.rotationEnabled
      });
    }
  }, {
    key: "_zoom",
    get: function get() {
      var o = this._get("_zoom"),
          t = this.lods || this._defaultLODs,
          e = this.minZoom,
          s = this.maxZoom,
          r = this.minScale,
          i = this.maxScale,
          a = this.snapToZoom;

      return o && o.lods === t && o.minZoom === e && o.maxZoom === s && o.minScale === r && o.maxScale === i && o.snapToZoom === a ? o : new n({
        lods: t,
        minZoom: e,
        maxZoom: s,
        minScale: r,
        maxScale: i,
        snapToZoom: a
      });
    }
  }, {
    key: "canZoomInTo",
    value: function canZoomInTo(o) {
      var t = this.effectiveMaxScale;
      return 0 === t || o >= t;
    }
  }, {
    key: "canZoomOutTo",
    value: function canZoomOutTo(o) {
      var t = this.effectiveMinScale;
      return 0 === t || o <= t;
    }
  }, {
    key: "constrain",
    value: function constrain(o, t) {
      return this._zoom.constrain(o, t), this._rotation.constrain(o, t), this._geometry.constrain(o, t), o;
    }
  }, {
    key: "constrainByGeometry",
    value: function constrainByGeometry(o) {
      return this._geometry.constrain(o);
    }
  }, {
    key: "fit",
    value: function fit(o) {
      return this._zoom.fit(o);
    }
  }, {
    key: "zoomToScale",
    value: function zoomToScale(o) {
      return this._zoom.zoomToScale(o);
    }
  }, {
    key: "scaleToZoom",
    value: function scaleToZoom(o) {
      return this._zoom.scaleToZoom(o);
    }
  }, {
    key: "snapScale",
    value: function snapScale(o) {
      return this._zoom.snapToClosestScale(o);
    }
  }, {
    key: "snapToNextScale",
    value: function snapToNextScale(o) {
      return this._zoom.snapToNextScale(o);
    }
  }, {
    key: "snapToPreviousScale",
    value: function snapToPreviousScale(o) {
      return this._zoom.snapToPreviousScale(o);
    }
  }]);

  return c;
}(t.EventedAccessor);

o([e({
  readOnly: !0,
  aliasOf: "_zoom.effectiveLODs"
})], c.prototype, "effectiveLODs", void 0), o([e({
  readOnly: !0,
  aliasOf: "_zoom.effectiveMinScale"
})], c.prototype, "effectiveMinScale", void 0), o([e({
  readOnly: !0,
  aliasOf: "_zoom.effectiveMaxScale"
})], c.prototype, "effectiveMaxScale", void 0), o([e({
  readOnly: !0,
  aliasOf: "_zoom.effectiveMinZoom"
})], c.prototype, "effectiveMinZoom", void 0), o([e({
  readOnly: !0,
  aliasOf: "_zoom.effectiveMaxZoom"
})], c.prototype, "effectiveMaxZoom", void 0), o([e({
  types: p,
  value: null
})], c.prototype, "geometry", null), o([e({
  type: [r]
})], c.prototype, "lods", void 0), o([e()], c.prototype, "minScale", void 0), o([e()], c.prototype, "maxScale", void 0), o([e()], c.prototype, "minZoom", void 0), o([e()], c.prototype, "maxZoom", void 0), o([e()], c.prototype, "rotationEnabled", void 0), o([e()], c.prototype, "snapToZoom", void 0), o([e()], c.prototype, "view", void 0), o([e()], c.prototype, "_defaultLODs", null), o([e({
  type: i
})], c.prototype, "_geometry", null), o([e({
  type: a
})], c.prototype, "_rotation", null), o([e({
  readOnly: !0,
  type: n
})], c.prototype, "_zoom", null), c = o([s("esri.views.2d.MapViewConstraints")], c);
var y = c;
export { y as default };